<template>
    <span
        class="text-cell"
        :data-test-id="dataTestId"
    >
        {{ value }}
    </span>
</template>

<script>
export default {
    name: 'TextCell',

    props: {
        dataTestId: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: null,
        },
    },
}
</script>

<style lang="scss" scoped>
.text-cell {
    display: block;
    width: 100%;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
}
</style>
